<template>
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div class="body-wrap">
        <cus-button color="gray-noFocus" text="周邊管理" @click="openOrderDialog('deviceSetting')"></cus-button>
        <cus-button
          color="gray-noFocus"
          :text="getIsTestMode ? '關閉練習模式' : '切換練習模式'"
          @click="toggleMode"
        ></cus-button>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="返回" color="blue" @click="close"></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>

  <!-- 各式彈窗 -->
  <component :is="orderDialogTemplate"></component>
</template>

<script>
import { inject, defineAsyncComponent, getCurrentInstance } from 'vue';
import { useGetters, useMutations } from '@/utils/mapStore';
import { useOrderDialog } from '@/utils/manageOrderDialog';

export default {
  name: 'setting',
  components: {
    DeviceSetting: defineAsyncComponent(() => import('@/components/orderDialog/DeviceSetting.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();

    // 接受provide值
    const close = inject('inner_close');

    // 開啟彈窗
    const { orderDialogTemplate, openOrderDialog } = useOrderDialog();

    // 切換練習模式
    const getIsTestMode = useGetters('system', ['getIsTestMode']);
    const SET_TEST_MODE = useMutations('system', ['SET_TEST_MODE']);
    const toggleMode = () => {
      if (!getIsTestMode.value) {
        proxy
          .$confirm({
            content: '確定要切換為練習模式？',
            confirmText: '切換',
            confirm2Text: '取消',
            moreConfirm: true,
          })
          .then((val) => {
            if (val === '切換') {
              SET_TEST_MODE(true);
              close();
            }
          })
          .catch((e) => e);
      } else {
        SET_TEST_MODE(false);
      }
    };

    return {
      close,
      orderDialogTemplate,
      openOrderDialog,
      toggleMode,
      getIsTestMode,
    };
  },
};
</script>

<style lang="scss" scoped>
.body-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 120px);
  grid-gap: 8px;
  padding: 0 4px;
}
</style>
